import React from 'react';

import Button from 'components/Button';
import {formatDateTime} from 'utils/datetime';

import './styles.css';

const Message = ({
  createdByName,
  createdAt,
  text,
  showMoreButton,
  toggleShowMore,
  showResolveButton,
  resolveNote,
  isResolved,
  resolvedAt,
  resolvedByName
}) => (
  <div className="Message">
    <div className="nameAndHour">
      <div className="name">{createdByName}</div>
      <div className="hour">{formatDateTime(createdAt)}</div>
    </div>
    <div className="text">
      <span>{text}</span>
      {showMoreButton && (
        <span className="seeMore" onClick={toggleShowMore}>
          {' '}
          see more
        </span>
      )}
      <div className="buttons">
        {showResolveButton && (
          <Button
            blue
            className="resolveButton colab-centered colab-centered-h"
            onClick={resolveNote}>
            Resolve
          </Button>
        )}
      </div>
      {isResolved && (
        <div className="resolvedByContainer">
          Resolved by {resolvedByName} {formatDateTime(resolvedAt)}
        </div>
      )}
    </div>
  </div>
);

export default Message;
